import { SxProps, Theme } from '@mui/material';

export const productCardContainerSX: SxProps<Theme> = () => ({
	border: '1px solid #DADCE0',
	height: {
		xs: '350px',
		sm: '440px',
	},
	width: {
		xs: '200px',
		sm: '290px',
	},
	flex: '0 0 auto',
});

export const productCardTopButtonsSX: SxProps<Theme> = () => ({
	display: 'flex',
	flexDirection: {
		xs: 'column',
		sm: 'row',
	},
	alignItems: {
		sm: 'center',
	},
});

export const productCardSelectedBorderSX = (selected: boolean): SxProps<Theme> => ({
	width: '22px',
	height: '22px',
	borderRadius: '50%',
	border: selected ? '1px solid #2F2F2F' : '1px solid #CCC',
});

export const productCardSelectedCenterSX = (color: string): SxProps<Theme> => ({
	width: '100%',
	height: '100%',
	borderRadius: '50%',
	border: '1px solid white',
	backgroundColor: color,
});
